export default class Reference {
  constructor(els, args) {
    this.els = els;
    this.args = args;
    this.initialize();
  }

  initialize() {
    console.log(this);
    //hide all els and add data attribute. Insert button with index text
    this.els.forEach((el, index) => {
      el.dataset.index = index;
      el.insertAdjacentHTML(
        'afterbegin',
        `<span class="reference-number">${index + 1}: </span>`
      );
      el.insertAdjacentHTML(
        'beforebegin',
        `<button class="reference-button" data-index="${index}"><span class="reference-id">${index + 1}</span><span class="reference-close hidden">x</span></button>`
      );
      el.classList.add('hidden');
    });
    this.clickhandler([...document.querySelectorAll('.reference-button')]);
  }

  clickhandler(els) {
    els.forEach((el) => {
      el.addEventListener('click', (e) => {
        this.showreference(e.target);
      });
      el.childNodes.forEach((child) => {
        console.log(child);
        child.addEventListener('click', (e) => {
          this.showreference(e.target.closest('.reference-button'));
        });
      });
    });
  }

  showreference(el) {
    console.log(el);
    console.log(`showing reference ${el.dataset.index}  `);
    const targetel = el;
    const index = targetel.dataset.index;
    this.els.forEach((refel) => {
      if (parseInt(refel.dataset.index) === parseInt(index)) {
        refel.classList.toggle('hidden');
        targetel.querySelector('.reference-id').classList.toggle('hidden');
        targetel.querySelector('.reference-close').classList.toggle('hidden');
      }
    });
  }
}
